import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Formik } from "formik";
import { ACTION_TYPE, REPORT_NAME } from "../../components/constant/reportType";
import { useDispatch } from "react-redux";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { alertMessage } from "../../utils/AlertService";
import * as Yup from "yup";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { useGetAllCountryMutation, useGetCountryByIdMutation, useSaveCountryMutation, useUpdateCountryMutation } from "../../redux-toolkit/services/countryService";
import { useGetStateByIdMutation, useGetStateMutation, useSaveStateMutation, useUpdateStateMutation } from "../../redux-toolkit/services/stateService";
import { getFindStateByCountryNameDetail, setStates } from "../../redux-toolkit/slices/statesSlice";
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import Loading from "../Loading";
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

type Props = {
  setShow: any;
  show: any;
  actionType: ACTION_TYPE;
  data?: any;
  setReportData?: any;
  getAllReportAsync: () => void;
  updateAllReportAsync: (values: any) => void;
  reportName?: string;
  isSelect?: boolean;
  setCall?: any;
  call?: any;
};


const CommonData = (props: Props) => {
  const token: any = getLocalStorageData("localUser").token;
  const dispatch = useDispatch();

  //selector
  const allCountries: any = useAppSelector(getAllcountryDetail);
  const allStates: any = useAppSelector(getFindStateByCountryNameDetail);

  //state
  const [getByIdData, setGetByIdData]: any = useState();
  const [country, setCountry]: any = useState();

  //getData
  const [getCountry, getCountryResponse] = useGetAllCountryMutation();
  const [getState, getStateResponse] = useGetStateMutation();

  //save
  const [saveCountry, saveCountryResponse] = useSaveCountryMutation();
  const [saveState, saveStateResponse] = useSaveStateMutation();
  const [logAudit] = useSaveAuditLogMutation();
  //update
  const [updateCountry, updateCountryResponse] = useUpdateCountryMutation();
  const [updateState, updateStateResponse] = useUpdateStateMutation();

  //getById mutation
  const [getCountryById, getCountryByIdResponse] = useGetCountryByIdMutation();
  const [getStateById, getStateByIdResponse] = useGetStateByIdMutation();


  const [selectedValue, setSelectedValue] = useState(
    props.actionType === ACTION_TYPE.UPDATE_ACTION &&
      props.reportName === REPORT_NAME.STATE
      ? props.data.countryId
      : ""
  );

  useEffect(() => {
    if (getCountryResponse.isSuccess) {
      dispatch(setcountry(getCountryResponse));
    } else if (getCountryResponse.isError) {
      let response: any = getCountryResponse.error;
      alertMessage(response, "error");
    }
  }, [getCountryResponse.isSuccess, getCountryResponse.isError]);

  useEffect(() => {
    if (getStateResponse.isSuccess) {
      dispatch(setStates(getStateResponse));
    } else if (getStateResponse.isError) {
      let response: any = getStateResponse.error;
      alertMessage(response, "error");
    }
  }, [getStateResponse.isSuccess, getStateResponse.isError]);

  useEffect(() => {
    if (props.reportName === REPORT_NAME.STATE) {
      if (allStates) {
        setStates(allStates);
      }
    }
  }, [allStates]);

  useEffect(() => {
    if (props.reportName === REPORT_NAME.STATE) {
      if (
        props.actionType === ACTION_TYPE.UPDATE_ACTION ||
        props.actionType === ACTION_TYPE.ADD_ACTION
      ) {
        getCountry({});
      }
    }
  }, []);

  // handleSubmit...........
  const handleSubmit = (values: any) => {
    if (props.actionType === ACTION_TYPE.ADD_ACTION) {
      if (props.reportName === REPORT_NAME.COUNTRY) {
        saveCountry({
          token: token,
          payload: {
            name: values.name,
            status: true,
          },
        });
      } else if (props.reportName === REPORT_NAME.STATE) {
        saveState({
          token: token,
          payload: {
            countryId: parseInt(selectedValue),
            // countryName: country,
            name: values.name,
            status: true,
          },
        });
      }
    } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
      if (props.reportName === REPORT_NAME.COUNTRY) {
        updateCountry({
          token: token,
          payload: {
            id: props.data.id,
            name: values.name,
            status: true,
          },
        });
      } else if (props.reportName === REPORT_NAME.STATE) {
        updateState({
          token: token,
          payload: {
            id: props?.data?.id,
            countryId: parseInt(selectedValue),
            countryName: country,
            name: values.name,
            status: true,
          },
        });
      }
    }
  };

  useEffect(() => {
    if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
      if (props.reportName === REPORT_NAME.COUNTRY) {
        getCountryById({
          token: token,
          id: props?.data?.id,
        });
      } else if (props.reportName === REPORT_NAME.STATE) {
        getStateById({
          token: token,
          id: props?.data?.id,
        });
      }
    }
  }, []);

  useEffect(() => {
    if (getCountryByIdResponse.isSuccess) {
      setGetByIdData(getCountryByIdResponse.data);
    } else if (getCountryByIdResponse.isError) {
      let response: any = getCountryByIdResponse?.error;
      alertMessage(response, "error");
    }
  }, [getCountryByIdResponse.isSuccess, getCountryByIdResponse.isError]);

  useEffect(() => {
    if (getStateByIdResponse.isSuccess) {
      setGetByIdData(getStateByIdResponse.data);
    } else if (getStateByIdResponse.isError) {
      let response: any = getStateByIdResponse?.error;
      alertMessage(response, "error");
    }
  }, [getStateByIdResponse.isSuccess, getStateByIdResponse.isError]);

  const handleClose = () => props.setShow(false);

  const handleSelectChange = (event: any) => {
    setSelectedValue(event.target.value);
    const countryName = allCountries.filter(
      (country: any) => country.id == event.target.value
    );
    setCountry(countryName[0].name);
  };

  // Save Country
  useEffect(() => {
    if (saveCountryResponse.isSuccess) {
      alertMessage("Country added successfully", "success");

      // Audit log
      const payload = {
        tableName: REPORT_NAME.COUNTRY,
        recordId: saveCountryResponse?.data?.id,
        operationType: "SAVE",
        oldValue: null,
        newValue: saveCountryResponse?.data,
      };

      logAudit({
        token: token,
        payload: payload,
      });

      props.setCall("Y");
      handleClose();
    } else if (saveCountryResponse.isError) {
      let response: any = saveCountryResponse?.error;
      alertMessage(response, "error");
    }
  }, [saveCountryResponse.isSuccess, saveCountryResponse.isError]);

  // Update Country
  useEffect(() => {
    if (updateCountryResponse.isSuccess) {
      alertMessage("Country updated successfully", "success");

      // Audit log
      const payload = {
        tableName: REPORT_NAME.COUNTRY,
        recordId: updateCountryResponse?.data?.id,
        operationType: "UPDATE",
        oldValue: getCountryByIdResponse?.data, // previous data
        newValue: updateCountryResponse?.data,  // updated data
      };

      logAudit({
        token: token,
        payload: payload,
      });

      props.setCall("Y");
      handleClose();
    } else if (updateCountryResponse.isError) {
      let response: any = updateCountryResponse?.error;
      alertMessage(response, "error");
    }
  }, [updateCountryResponse.isSuccess, updateCountryResponse.isError]);

  // Save State
  useEffect(() => {
    if (saveStateResponse.isSuccess) {
      alertMessage("State added successfully", "success");

      // Audit log
      const payload = {
        tableName: REPORT_NAME.STATE,
        recordId: saveStateResponse?.data?.id,
        operationType: "SAVE",
        oldValue: null,
        newValue: saveStateResponse?.data,
      };

      logAudit({
        token:token,
        payload: payload,
      });

      props.setCall("Y");
      handleClose();
    } else if (saveStateResponse.isError) {
      let response: any = saveStateResponse?.error;
      let msg: any = response.data?.serviceErrors[0]?.msg;
      alertMessage(msg, "error");
    }
  }, [saveStateResponse.isSuccess, saveStateResponse.isError]);

  // Update State
  useEffect(() => {
    if (updateStateResponse.isSuccess) {
      alertMessage("State updated successfully", "success");

      // Audit log
      const payload = {
        tableName: REPORT_NAME.STATE,
        recordId: updateStateResponse?.data?.id,
        operationType: "UPDATE",
        oldValue: getStateByIdResponse?.data, // previous data
        newValue: updateStateResponse?.data,  // updated data
      };

      logAudit({
        token: token,
        payload: payload,
      });

      props.setCall("Y");
      handleClose();
    } else if (updateStateResponse.isError) {
      let response: any = updateStateResponse?.error;
      let msg: any = response.data?.serviceErrors[0]?.msg;
      alertMessage(msg, "error");
    }
  }, [updateStateResponse.isSuccess, updateStateResponse.isError]);


  return (
    <div>
      {/* <!-- Modal --> */}
      <Modal
        show={props.show}
        onHide={handleClose}
        className=""
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-90w"
      >
        <Modal.Header>
          <Modal.Title
            className="fw-bold text-accent"
            style={{ fontSize: "1rem" }}
          >
            {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
            {props.reportName}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
           {getCountryResponse.isLoading ||
            getStateResponse.isLoading ||
            getCountryByIdResponse.isLoading ||
            getStateByIdResponse.isLoading ||
            saveCountryResponse.isLoading ||
            saveStateResponse.isLoading ||
            updateCountryResponse.isLoading ||
            updateStateResponse.isLoading ? (
            <Loading />
          ) : (
            ""
          )}

          <Formik
            // validationSchema={formSchema}
            enableReinitialize={true}
            initialValues={{
              name:
                props.actionType === ACTION_TYPE.UPDATE_ACTION
                  ? getByIdData && getByIdData.name
                  : "",
              select:
                props.actionType === ACTION_TYPE.UPDATE_ACTION &&
                  props.reportName === REPORT_NAME.STATE
                  ? getByIdData && getByIdData.countryId
                  : "",
            }}
            onSubmit={handleSubmit}
          >
            {({ values, handleChange }) => (
              <Form>
                <>
                  {props.isSelect && (
                    <p>
                      <div className="w-100">
                        <div className="d-flex">
                          <div> Select Country </div>
                          <div style={{ color: "red" }}>*</div>
                        </div>
                        <div className="pe-2">
                          <select
                            className="form-select form-select-sm w-100"
                            aria-label=".form-select-sm example"
                            onChange={handleSelectChange}
                            name="select"
                            value={selectedValue}
                          >
                            <option value="">Select Country </option>
                            {allCountries &&
                              allCountries.map((itemType: any, index: any) => {
                                return (
                                  <option
                                    key={index.toString()}
                                    value={itemType.id}
                                  >
                                    {itemType.name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                      </div>
                    </p>
                  )}
                  <p>
                    <div className="d-flex">
                      <div> {props.reportName} Name</div>
                      <div style={{ color: "red" }}>*</div>
                    </div>
                    <input
                      className="form-control form-control-sm w-100"
                      type="text"
                      aria-label=".form-control-sm example"
                      onChange={handleChange}
                      value={values.name}
                      name="name"
                      required
                    />
                  </p>
                </>
                <div className="d-flex flex-row justify-content-center">
                  <button
                    type="submit"
                    className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                  >
                    {props.actionType === ACTION_TYPE.ADD_ACTION
                      ? "Save"
                      : "Update"}
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary btn-sm btn-block mt-3 mx-2 btn-width"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default CommonData;
